import { render, staticRenderFns } from "./SwitchOfflineFile.vue?vue&type=template&id=2aa6f5b6&"
import script from "./SwitchOfflineFile.vue?vue&type=script&lang=js&"
export * from "./SwitchOfflineFile.vue?vue&type=script&lang=js&"
import style0 from "./SwitchOfflineFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports